import {SVGProps} from 'react';

const Icon = (props: SVGProps<SVGSVGElement>) => (
    <svg
        fill="none"
        height="16"
        viewBox="0 0 16 16"
        width="16"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="M9 6.5L6.5 9M6.5 9L2.19165 6.60647C2.11671 6.56484 2.12547 6.45438 2.20604 6.42508L12.7986 2.57323C12.8784 2.54421 12.9558 2.62158 12.9268 2.70138L11 8M6.5 9L7.05556 10"
            stroke="currentColor"
            strokeLinecap="round"
        />
        <path
            d="M8.5 11.5L10 13L13 10"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);

export default Icon;
